import { type FC, isValidElement } from 'react';

import { useExcelImporterStepperContext } from '@/views/AdminDashboard/components/ExcelImporterStepper/context';

import type {
  TContextPopulatedComponent,
  TCustomComponent,
} from '../../context/types';

interface IContextInjectedWrapperProps {
  component?: TCustomComponent;
  extraProps?: Record<string, unknown>;
}

const ContextInjectedWrapper: FC<IContextInjectedWrapperProps> = ({
  component: Component,
  extraProps,
}) => {
  const context = useExcelImporterStepperContext();

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!Component) return null;

  if (isValidElement(Component)) {
    return <>{Component}</>;
  } else {
    const ComponentElement = Component as TContextPopulatedComponent;
    return <ComponentElement {...context} {...extraProps} />;
  }
};
export default ContextInjectedWrapper;
